/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import MobilePhotoCaptureComponent from "../MobilePhotoCaptureComponent.jsx";
import {FileSystem} from "../../APIClient.jsx";
import {Util} from "../../Utilities.js";

class CameraCaptureImage extends Component {
    render() {
        let {title, children, onClose, onCapture, basePath} = this.props
        return (
            <div className=" fixed inset-0 backdrop-blur-sm bg-white/30 z-50  px-4 py-4 ">

                <div className={"flex flex-col"}>
                    <div className="flex flex-row-reverse flex-shrink-0">
                        <button type="button"
                                onClick={() => {
                                    if (onClose !== undefined) {
                                        onClose()
                                    }
                                }}
                                className="inline-flex rounded-md  text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                            <span className="sr-only">Close</span>
                            <svg className="h-12 w-12" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path
                                    d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
                            </svg>
                        </button>
                    </div>
                    <div className="  flex-1 pt-0.5 ">
                        <p className="text-sm font-medium text-gray-900">{title}</p>
                        <div className={"mt-12 "}>

                            <div className={"flex justify-center align-middle"}>

                                <MobilePhotoCaptureComponent onImageCapture={(image) => {
                                    if (onCapture !== undefined) {
                                        let key = basePath + "imageCapture_" + Util.unique.newInternalId() + ".jpeg"

                                        // upload the file
                                        FileSystem.put(key, image, "").then(data => {
                                            onCapture(key)
                                        })
                                    }
                                }}/>

                            </div>
                        </div>
                    </div>
                </div>


                <div className={"w-full h-full"}>


                </div>

            </div>

        );
    }
}

CameraCaptureImage.propTypes = {};

export default CameraCaptureImage;